import React from 'react';

export default function Poster ({ src, className = '', style = {} }) {
  return (
    <img src={src} className={'Poster ' + (className)} style={style} />
  );
};



// WEBPACK FOOTER //
// ./client/Core/Components/Poster.jsx